import { Select } from '@mantine/core';

interface LanguageSelectorProps {
    value: string | undefined;
    onChange: (value: string | null) => void;
    rightSection?: React.ReactNode;
    className?: string;
}

export default function LanguageSelector({ value, onChange, rightSection, className }: LanguageSelectorProps): JSX.Element {
    return (
        <Select
            className={className}
            value={value}
            rightSection={rightSection}
            onChange={onChange}
            data={[
                { label: 'English', value: 'en' },
                { label: 'Español', value: 'es' },
                { label: 'Português', value: 'pt' },
            ]}
        />
    );
}
